import { ToolsState } from "@/components/ToolsPage/redux/types";

const toolsInitialState: ToolsState = {
  content: null,
  toolData: null,
  type: "",
  seo: null,
};

export default toolsInitialState;
